import React, { useEffect } from "react";

const AriaLabels: React.FC = () => {
  useEffect(() => {
    // הוספת ARIA labels אוטומטית
    const addAriaLabels = () => {
      // הוספת alt לכל התמונות
      const images = document.querySelectorAll('img:not([alt]), img[alt=""]');
      images.forEach((img, index) => {
        if (!img.getAttribute("alt")) {
          const src = img.getAttribute("src") || "";
          const fileName =
            src.split("/").pop()?.split(".")[0] || `תמונה ${index + 1}`;
          img.setAttribute("alt", fileName);
        }
      });

      // הוספת aria-label לכפתורים
      const buttons = document.querySelectorAll(
        "button:not([aria-label]):not([aria-labelledby])"
      );
      buttons.forEach((button, index) => {
        if (!button.textContent?.trim()) {
          button.setAttribute("aria-label", `כפתור ${index + 1}`);
        }
      });

      // הוספת aria-label לקישורים
      const links = document.querySelectorAll(
        "a:not([aria-label]):not([aria-labelledby])"
      );
      links.forEach((link, index) => {
        if (!link.textContent?.trim() && !link.querySelector("img")) {
          link.setAttribute("aria-label", `קישור ${index + 1}`);
        }
      });

      // הוספת role לטפסים - רק אם אין להם role כבר
      const forms = document.querySelectorAll("form");
      forms.forEach((form) => {
        // לא להוסיף role="form" כי זה כבר ברירת מחדל
        if (form.getAttribute("aria-label")) {
          // רק להוסיף aria-label אם יש תוכן
        }
      });

      // הוספת aria-required לשדות חובה
      const requiredInputs = document.querySelectorAll(
        "input[required], textarea[required], select[required]"
      );
      requiredInputs.forEach((input) => {
        input.setAttribute("aria-required", "true");
      });

      // הוספת aria-describedby לשדות עם שגיאות
      const errorInputs = document.querySelectorAll(
        'input[aria-invalid="true"], textarea[aria-invalid="true"]'
      );
      errorInputs.forEach((input) => {
        const errorMessage = input.parentElement?.querySelector(
          '.error-message, .error, [role="alert"]'
        );
        if (errorMessage) {
          input.setAttribute(
            "aria-describedby",
            errorMessage.id || "error-message"
          );
        }
      });
    };

    // הוספת landmarks
    const addLandmarks = () => {
      // הוספת main landmark - רק אם אין כבר
      const mainContent =
        document.querySelector("main") || document.querySelector("#root");
      if (mainContent && !mainContent.getAttribute("role")) {
        // בדיקה שהאלמנט באמת צריך role
        if (
          mainContent.tagName !== "MAIN" &&
          mainContent.tagName !== "HEADER" &&
          mainContent.tagName !== "FOOTER" &&
          mainContent.tagName !== "NAV"
        ) {
          mainContent.setAttribute("role", "main");
          mainContent.id = "main-content";
        }
      }

      // הוספת main landmark לכל הדפים - רק אם אין להם role כבר
      const pages = document.querySelectorAll(
        '[data-testid="page"], .page, .main-content'
      );
      pages.forEach((page, index) => {
        // לא להוסיף role אם יש כבר
        if (!page.getAttribute("role") && !page.closest("[role]")) {
          // בדיקה שהאלמנט באמת צריך role
          if (
            page.tagName !== "MAIN" &&
            page.tagName !== "HEADER" &&
            page.tagName !== "FOOTER" &&
            page.tagName !== "NAV"
          ) {
            page.setAttribute("role", "main");
            if (!page.id) {
              page.id = `main-content-${index}`;
            }
          }
        }
      });

      // הוספת navigation landmarks
      const navs = document.querySelectorAll("nav");
      navs.forEach((nav, index) => {
        if (!nav.getAttribute("aria-label")) {
          nav.setAttribute("aria-label", `ניווט ${index + 1}`);
        }
      });

      // הוספת banner landmark
      const header = document.querySelector("header");
      if (header && !header.getAttribute("role")) {
        header.setAttribute("role", "banner");
      }

      // הוספת contentinfo landmark
      const footer = document.querySelector("footer");
      if (footer && !footer.getAttribute("role")) {
        footer.setAttribute("role", "contentinfo");
      }
    };

    // לא מוסיפים תמיכה במקלדת כאן - כפתורים כבר תומכים במקלדת באופן טבעי
    // לא מוסיפים event listeners מיותרים - זה יכול ליצור בעיות performance
    const addKeyboardSupport = () => {
      // כפתורים כבר focusable וניתן להפעיל אותם עם Enter/Space
      // לא צריך להוסיף tabindex או event listeners מיותרים
    };

    // הפעלת כל הפיצ'רים
    addAriaLabels();
    addLandmarks();
    addKeyboardSupport();

    // הפעלה מחדש כשהתוכן משתנה
    const observer = new MutationObserver(() => {
      addAriaLabels();
      addLandmarks();
      addKeyboardSupport();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return null;
};

export default AriaLabels;
